
import React from 'react';
import { withResource, resourceTypes, gettersOf } from 'dataModule/store/resources';
import { fetchGoThumbSignedUrl } from 'utilsModule/gothumb';
import { Loading } from 'utilsModule/components';
import DAFForm from '../components/DAFForm';
import { withNamespaces } from 'react-i18next';
import { isEqual } from 'lodash';
import DM from 'dataModule';
import { buildOrganizationAddressParts } from 'appModule/program/components/ConsentForm';

const runtimeProps = (props) => ({
  toSync: {
    'clinicLogoUrl': props.clinicLogoUrl,
    'clinicName': props.clinicName,
    'effectiveDate': props.effectiveDate,
  },
  syncHtml: (html, toSync) => {
    const _syncHtml = (_html) => {
      return _html.map((e) => {
        if (e.childrens) {
          _syncHtml(e.childrens)
        } else {
          if (e.syncValue && e.id) {
            if (e.tag === 'img') {
              e.props.src = toSync[e.id]
            } else {
              e.value = toSync[e.id]
            }
          }
        }
        return e;
      })
    }
    const result = _syncHtml(html);
    return result;
  }
})

const buildDocumentConfigData = (documentConfig = {}, organization = {}, clinicLogoUrl = '') => {
  const baseData = (documentConfig && documentConfig.data) || {};
  const headerData = baseData.header || {};
  const address = buildOrganizationAddressParts(organization);
  const hotlineNumber = headerData.hotlineNumber || '';
  const whatsappNumber = headerData.whatsappNumber || '';
  const website = headerData.website || '';
  const emailAddress = headerData.emailAddress || '';
  const contactItems = [
    hotlineNumber ? `Hotline: ${hotlineNumber}` : null,
    whatsappNumber ? `WhatsApp: ${whatsappNumber}` : null,
    website ? `Website: ${website}` : null,
    emailAddress ? `Email: ${emailAddress}` : null,
  ].filter(Boolean);

  return {
    ...baseData,
    header: {
      ...headerData,
      organizationName: organization.name || '',
      organizationRegNo: organization.regNo || '',
      organizationDisplayName: organization.name
        ? `${organization.name}${organization.regNo ? ` (${organization.regNo})` : ''}`
        : '',
      organizationLogo: clinicLogoUrl || '',
      organizationLogoStyle: clinicLogoUrl ? '' : 'display:none;',
      organizationAddressLine1: address.line1,
      organizationAddressLine2: address.line2,
      organizationAddress: address.full,
      organizationAddressStyle: address.full ? '' : 'display:none;',
      hotlineNumber,
      whatsappNumber,
      website,
      emailAddress,
      contactInfoLine: contactItems.join(' | '),
      contactInfoStyle: contactItems.length ? '' : 'display:none;',
    },
    footer: {
      ...(baseData.footer || {}),
    },
  };
}

@withResource([
  {
    resourceType: resourceTypes.CONTRACTS,
    method: 'retrieveContractFormByUuid',
    input: ({ location: { query: params } }) => ({
      params: {
        queries: [
          { name: 'type', value: 'DAF' },
          { name: 'uuid', value: params.uuid },
          { name: 'session-token', value: params['session-token'] },
        ],
      },
    }),
    options: { runOnDidMount: true, forceFetch: true },
  },
])
@withNamespaces('modules', { wait: true })
class DAFFormReadOnlyContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openSignaturePad: false,
      target_signature_id: null,
      awaitPerformAction: false,
      clinicLogoUrl: null,

      formData: {
        patientName: null,
        version: 1,
        preSignCheck: [
          false,
          false,
          false
        ],
        guardianName: null,
        guardianSignature: null,
        patientSignature: null,
        clinicName: null,
        clinicianName: null,
        clinicianSignature: null,
      }
    };

    this.onChange = this.onChange.bind(this);
    this.handleSignaturePad = this.handleSignaturePad.bind(this);

    const { location: { query: { clinicLogoFilename } } } = this.props;
    if (clinicLogoFilename) {
      fetchGoThumbSignedUrl(clinicLogoFilename, this.props.location.query['session-token'])
        .then(url => this.setState({ clinicLogoUrl: url }))
        .catch(() => null);
    }
    if (this.props.location.query['session-language']) {
      this.props.i18n.changeLanguage(this.props.location.query['session-language']);
    }
  }

  async componentDidMount() {
    await this.loadHtml();
  }

  async componentDidUpdate(prevProps, newState) {
    if (!isEqual(prevProps.data, this.props.data)) {
      await this.loadHtml();
    }
  }

  loadHtml = async () => {
    const { i18n: { language }, data, location: { query: params } } = this.props;

    const contracts = gettersOf(resourceTypes.CONTRACTS).retrieveContractFormByUuid()(data);

    if (contracts && contracts.value) {

      const organization = contracts.value.organization || {};
      const orgId = organization.id || contracts.value.orgId || Number(params.orgId) || 0;
      const clinicLogoUrl = this.state.clinicLogoUrl || (organization.logoUrl ? await fetchGoThumbSignedUrl(organization.logoUrl, params['session-token']).catch(() => null) : null);

      let { value } = await DM.program.provider.getEnrollmentFormTemplate({
        orgId,
        formType: 'loan',
        language: language,
        sessionToken: params['session-token']
      });

      if (value && value.html) {
        const _runtimeProps = runtimeProps({ clinicLogoUrl, clinicName: contracts.value.clinicName, effectiveDate: contracts.value.effectiveDate || new Date().toISOString() });
        try {
          const b = _runtimeProps.syncHtml(value.html, _runtimeProps.toSync);
          console.log(b);
          value.html = b;
        } catch (e) {
          console.log(e)
        }
        value.html = _runtimeProps.syncHtml(value.html, _runtimeProps.toSync);
      }

      if (value && value.documentConfig) {
        value.documentConfig = {
          ...value.documentConfig,
          data: buildDocumentConfigData(value.documentConfig, organization, clinicLogoUrl),
        };
      }

      let patientName = null;
      let clinicianName = null;

      this.setState(prevState => ({
        formTemplate: value,
        formData: {
          ...(prevState.formData === null) ? value.initialValue : prevState.formData,
          clinicianName: clinicianName,
          patientName: patientName
        },
      }), () => {
        console.log(this.state);
      })
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (!isEqual(this.state.formData.guardianName, nextState.formData.guardianName)) {
      return false
    }
    return true
  };

  onChange = (el, e) => {
    let newState = this.state.formData[e.props.name];
    if (e.props.type === 'checkBox') {
      newState[e.index] = el.target.checked;
    } else if (e.props.type === 'text') {
      newState = el.target.value;
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [e.props.name]: newState
      }
    }))
  }

  handleSignaturePad = (status = false, id = null, currentSrc) => {
    if (status) {
      this.setState({ openSignaturePad: status, target_signature_id: id })
    }
    if (id && currentSrc) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          [id]: currentSrc
        }
      }))
    }
    this.setState({ openSignaturePad: status })
  }

  render() {
    const { data, t } = this.props;
    const { clinicLogoUrl, openSignaturePad, target_signature_id, formTemplate } = this.state;
    const isReadOnly = true;


    if (data.status.loading) return <Loading />;
    const { value } = gettersOf(resourceTypes.CONTRACTS).retrieveContractFormByUuid()(data);
    const _formData = (isReadOnly) ? value : this.state.formData;
    return <DAFForm
      {...this.props}
      formName={'loan'}
      formData={_formData}
      isReadOnly={isReadOnly}
      clinicLogoUrl={clinicLogoUrl}
      formTemplate={formTemplate}
      onChange={this.onChange}
      handleSignaturePad={this.handleSignaturePad}
      openSignaturePad={openSignaturePad}
      target_signature_id={target_signature_id}
      t={t} />;
  }
}

export default DAFFormReadOnlyContainer;
